﻿
window.setupStickyMasthead = function () {

	var mastheads = document.getElementsByClassName("masthead-content");

	if (mastheads.length) {

		var masthead = mastheads[0];

		var sticky = masthead.offsetTop;


		function stickyScroll() {
			if (window.pageYOffset > sticky) {
				// add css class to masthead and body
				masthead.classList.add("sticky");
				document.body.classList.add("sticky");
			} else {
				// remove the css class from the masthead and body
				masthead.classList.remove("sticky");
				document.body.classList.remove("sticky");
			}
		}

		window.onscroll = function () { stickyScroll() };

	}

}

if (document.readyState !== 'loading') {
	window.setupStickyMasthead();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.setupStickyMasthead();
	});
}